import { ErrorStateMatcher } from '@angular/material/core';
import {AbstractControl, UntypedFormControl, FormGroupDirective, NgForm} from '@angular/forms';
import * as moment from 'moment';

export class CustomValidator {
  static listenSonderSummeValidierung(motorrad: boolean, expertMode: boolean): any {
    return (control: AbstractControl): any => {
      if (control.parent == null) {
        return null;
      }
      const listenpreis = control.parent.get('listenpreis');
      const sonderausstattung = control.parent.get('sonderausstattung');
  
      if (!listenpreis || !sonderausstattung) {
        return null;
      }
      if (
        (parseInt(listenpreis.value, 10) || 0) +
        (parseInt(sonderausstattung.value, 10) || 0) >
        (motorrad ? 30000 : expertMode ? 120000 : 100000)
      ) {
        return { sumTooHigh: true };
      }
      return null;
    };
  }

  static checkboxesRequiredValidierung(group): any {
    let checked = 0;
    Object.keys(group.controls).forEach(key => {
      const control = group.controls[key];
      if (control.value === true) {
        checked++;
      }
    });
    if (checked < 1) {
      return {
        requireCheckboxChecked: true
      };
    }
    return null;
  }

  static haftpflichtHundeValidierung(group): any {
    if (group.controls.haftpflichtHunde.value === 'ja') {
      if (!group.controls.haftpflichtAnzahlHunde.value) {
        group.controls.haftpflichtAnzahlHunde.setErrors({
          required: true
        });
      }
      if (!group.controls.haftpflichtAnzahlHunde.value) {
        return {
          required: true
        };
      }
    }
    return null;
  }

  static nebengebaeudeValidierung(group): any {
    if (group.controls.nebengebaeude.value === 'ja') {
      if (!group.controls.nebengebauedeBebauteFlaecheQm.value) {
        group.controls.nebengebauedeBebauteFlaecheQm.setErrors({
          required: true
        });
      }
      if (!group.controls.nebengebauedeBauweise.value) {
        group.controls.nebengebauedeBauweise.setErrors({
          required: true
        });
      }
      if (!group.controls.nebengebauedeBebauteFlaecheQm.value || !group.controls.nebengebauedeBauweise.value) {
        return {
          required: true
        };
      }
    }
    return null;
  }

  static katastrophenschutzValidierung(group): any {
    if (group.controls.katastrophenschutz.value === 'ja' && group.controls.gefahrenzoneRot.value === 'ja') {
      group.controls.katastrophenschutz.setErrors({
        gefahrenzoneRot: true
      });
    } else {
      if (group.controls.katastrophenschutz.hasError('gefahrenzoneRot')) {
        delete group.controls.katastrophenschutz.errors['gefahrenzoneRot'];
        group.controls.katastrophenschutz.updateValueAndValidity();
      }
    }
    return null;
  }

  static hoechsthaftungssummeHaushaltValidierung(group): any {
    const hoechsthaftungssummeMin = CustomValidator.hoechsthaftungssummeHaushaltMin(group);
    const hoechsthaftungssumme = group.controls.hoechsthaftungssummeFreieEingabe.value;
    if (hoechsthaftungssumme && group.controls.hoechsthaftungssumme.value) {
      if (hoechsthaftungssumme < hoechsthaftungssummeMin) {
        group.controls.hoechsthaftungssummeFreieEingabe.setErrors({
          min: {
            actual: hoechsthaftungssumme, min: hoechsthaftungssummeMin
          }
        });
      } else {
        const hoechsthaftungssummeMax = CustomValidator.hoechsthaftungssummeHaushaltMax();
        if (hoechsthaftungssumme > hoechsthaftungssummeMax) {
          group.controls.hoechsthaftungssummeFreieEingabe.setErrors({
            max: {
              actual: hoechsthaftungssumme, max: hoechsthaftungssummeMax
            }
          });
        }
      }
    }
    return null;
  }

  static hoechsthaftungssummeHaushaltMin(group): number {
    return group.controls.tarifVersicherungssumme ? Math.max(10000, group.controls.tarifVersicherungssumme.value * 0.75) : 10000;
    // if (group.controls.hoechsthaftungssumme.value && group.controls.einwandUnterversicherung.value === 'ja') {
    //   return 20000;
    // }
    // return group.controls.hoechsthaftungssumme.value ? group.controls.hoechsthaftungssumme.value : 0;
  }

  static hoechsthaftungssummeHaushaltMax(): number {
    return 400000;
    // const hoechsthaftungssummeMax = 400000;
    // if (group.controls.hoechsthaftungssumme.value && group.controls.einwandUnterversicherung.value === 'ja') {
    //   return group.controls.hoechsthaftungssumme.value > hoechsthaftungssummeMax ? hoechsthaftungssummeMax : group.controls.hoechsthaftungssumme.value;
    // }
    // return group.controls.hoechsthaftungssumme.value ? hoechsthaftungssummeMax : 0;
  }

  static hoechsthaftungssummeEigenheimValidierung(group): any {
    const hoechsthaftungssummeMin = CustomValidator.hoechsthaftungssummeEigenheimMin(group);
    const hoechsthaftungssumme = group.controls.hoechsthaftungssummeFreieEingabe.value;
    if (hoechsthaftungssumme && group.controls.hoechsthaftungssumme.value) {
      if (hoechsthaftungssumme < hoechsthaftungssummeMin) {
        group.controls.hoechsthaftungssummeFreieEingabe.setErrors({
          min: {
            actual: hoechsthaftungssumme, min: hoechsthaftungssummeMin
          }
        });
      } else {
        const hoechsthaftungssummeMax = CustomValidator.hoechsthaftungssummeEigenheimMax();
        if (hoechsthaftungssumme > hoechsthaftungssummeMax) {
          group.controls.hoechsthaftungssummeFreieEingabe.setErrors({
            max: {
              actual: hoechsthaftungssumme, max: hoechsthaftungssummeMax
            }
          });
        }
      }
    }
    return null;
  }

  static hoechsthaftungssummeEigenheimMin(group): number {
    return Math.max(10000, group.controls.tarifVersicherungssumme.value * 0.75);
  }

  static hoechsthaftungssummeEigenheimMax(): number {
    return 400000;
  }

  static hoechsthaftungssummeMin(group): number {
    return group.controls.tarifVersicherungssumme.value;
  }

  static hoechsthaftungssummeMinExpert(group): number {
    return group.controls.tarifVersicherungssumme ? Math.max(10000, group.controls.tarifVersicherungssumme.value * 0.75) : 10000;
  }

  static hoechsthaftungssummeMax(group): number {
    return group.controls.tarifVersicherungssumme ? Math.min(1000000, group.controls.tarifVersicherungssumme.value * 1.33) : 1000000;
  }

  static validateHoechsthaftungssummeHaushalt(group): any {
    CustomValidator.validateHoechsthaftungssumme(group, CustomValidator.hoechsthaftungssummeEigenheimMin(group), CustomValidator.hoechsthaftungssummeEigenheimMax());
    return null;
  }

  static validateHoechsthaftungssummeExpert(group, min = null): any {
    CustomValidator.validateHoechsthaftungssumme(
      group,
      min !== null ? min : CustomValidator.hoechsthaftungssummeMinExpert(group),
      CustomValidator.hoechsthaftungssummeMax(group));
    return null;
  }

  static validateHoechsthaftungssumme(group, min = null, max = null): any {
    const hoechsthaftungssummeMin = min ? min : CustomValidator.hoechsthaftungssummeMin(group);
    const hoechsthaftungssumme = group.controls.hoechsthaftungssummeFreieEingabe.value;
    if (hoechsthaftungssumme && hoechsthaftungssummeMin) {
      if (hoechsthaftungssumme < hoechsthaftungssummeMin) {
        group.controls.hoechsthaftungssummeFreieEingabe.setErrors({
          min: {
            actual: hoechsthaftungssumme, min: hoechsthaftungssummeMin
          }
        });
      } else {
        const hoechsthaftungssummeMax = max ? max : CustomValidator.hoechsthaftungssummeMax(group);
        if (hoechsthaftungssumme > hoechsthaftungssummeMax) {
          group.controls.hoechsthaftungssummeFreieEingabe.setErrors({
            max: {
              actual: hoechsthaftungssumme, max: hoechsthaftungssummeMax
            }
          });
        }
      }
    }
    return null;
  }

  static matchEmailOptional(group): any {
    const email = group.controls.email;
    const confirm = group.controls.confirm;
    if (!email.value && !confirm.value) {
      return null;
    }
    return CustomValidator.matchEmail(group);
  }

  static matchEmail(group): any {
    const email = group.controls.email;
    const confirm = group.controls.confirm;
    if (email.value && confirm.value && email.value.toUpperCase() === confirm.value.toUpperCase()) {
      if (confirm.hasError('mismatchEmail')) {
        delete confirm.errors['mismatchEmail'];
        confirm.updateValueAndValidity();
      }
      return null;
    }
    const mismatchEmail = {
      mismatchEmail: true
    };
    confirm.setErrors(mismatchEmail);
    return mismatchEmail;
  }

  static matchEmailExpertOptional(group): any {
    const email = group.controls.email;
    const confirm = group.controls.confirm;
    if (!email.value && !confirm.value) {
      return null;
    }
    return CustomValidator.matchEmailExpert(group);
  }

  static matchEmailExpert(group): any {
    const email = group.controls.email;
    const confirm = group.controls.confirm;
    if (!email.value || confirm.value && email.value.toUpperCase() === confirm.value.toUpperCase()) {
      if (confirm.hasError('mismatchEmail')) {
        delete confirm.errors['mismatchEmail'];
        confirm.updateValueAndValidity();
      }
      return null;
    }
    const mismatchEmail = {
      mismatchEmail: true
    };
    confirm.setErrors(mismatchEmail);
    return mismatchEmail;
  }

  static validateEmailOptional(control) {
    if (!control.value) {
      return null;
    }
    return CustomValidator.validateEmail(control);
  }

  static validateEmail(control) {
    // General Email Regex (RFC 5322 Official Standard)
    const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (control.value && !EMAIL_REGEXP.test(control.value)) {
      return {
        email: true
      };
    }
    return null;
  }

  static validateGeburtsdatum(control) {
    const now = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()));
    const hundredYearsAgo = moment(now).subtract(100, 'years');
    if (control.value && moment(control.value) < hundredYearsAgo) {
      return {
        geburtsdatum: true
      };
    }
    return null;
  }


  static validateAlter(value) {
    const currentControlDate = new Date(value);
    const geburtsdatumMaxDate = moment(new Date(new Date().getFullYear(), 0, 1)).subtract(75, 'years').toDate();
    const geburtsdatumMinDate = moment(new Date(new Date().getFullYear() + 1, 0, 1)).subtract(23, 'years').subtract(1, 'seconds').toDate();
    if (currentControlDate > geburtsdatumMaxDate && currentControlDate < geburtsdatumMinDate) {
      return true;
    }
    return false;
  }

  static validateKennzeichen(control) {
    const pattern = new RegExp(['^\\b(AM|B(A|L|M|N|R|Z)?|DL|DO|E(F|U)?|F(B|E|F|K|R)?|G(B|D|F|M|R|S|U)?|HA|HB|HE|HF|HL|HO|I(L|M)?' +
      '|JE|JO|JU|K(B|F|G|I|L|O|R|S|U)?|L(A|B|E|F|I|L|N|Z)?|MA|MD|ME|MI|MT|MU|MZ|ND|NK|OP|OW|P(E|L|A)?|RA|RE|RI|RO|S(B|D|E|L|O|P|R' +
      '|V|W|Z)?|TA|TU|UU|VB|VI|VK|VL|VO|W(B|E|L|N|O|T|U|Y|Z)?|ZE|ZT)-\\w+\\b$'].join(''));
    if (control.value && !pattern.test(control.value)) {
      return {
        pattern: true
      };
    }
    return null;
  }

  static requiredYes(control) {
    // General Match value is equal to ja
    if (control.value && control.value !== 'ja') {
      return {
        invalid: true
      };
    }
    return null;
  }

  static requiredNo(control) {
    // General Match value is equal to nein
    if (control.value && control.value !== 'nein') {
      return {
        invalid: true
      };
    }
    return null;
  }

  static requiredLookupValue(control) {
    if (!control.value ||
      typeof control.value === 'string') {
      return { lookupValue: true };
    }
    return null;
  }

  static addressPattern(control): any {
    // allow some special chars like . - \ /
    const pattern = /^[a-zA-ZÀ-Öø-ÿ0-9-\/\\\. ]*$/;
    if (control.value && !pattern.test(control.value)) {
      return {
        pattern: true
      };
    }
    return null;
  }

  static firstLastName(control): any {
    const pattern = /^[a-zA-ZÀ-ÖØ-öø-ÿ0-9]*[a-zA-ZÀ-ÖØ-öø-ÿ][a-zA-ZÀ-ÖØ-öø-ÿ0-9\s'-]*$/;
    if (control.value && !pattern.test(control.value)) {
      return {
        pattern: true
      };
    }
    return null;
  }

  static maxNutzlastLKW(formControl: AbstractControl){
    if (!formControl.parent) {
      return null;
    }
    if (formControl.parent.get('fahrzeugart').value && formControl.parent.get('fahrzeugart').value.Key === '6') {  // Privat LKW 1,5T
      if(formControl.value > 1500){
        return {
          max: {
            max: 1500, actual: formControl.value
          }
        };
      }
    }

    if (formControl.parent.get('fahrzeugart').value && formControl.parent.get('fahrzeugart').value.Key === '7') {  // LKW > 1t
      if(formControl.value < 1000){
        return {
          min: {
            actual: formControl.value, min: 1000
          }
        };
      }
    }
    if (formControl.parent.get('fahrzeugart').value && formControl.parent.get('fahrzeugart').value.Key === '8') {  // LKW < 1t
      if(formControl.value > 1000){
        return {
          max: {
            max: 1000, actual: formControl.value
          }
        };
      }
    }
    return null;
  }

  static maxGesamtgewicht(formControl: AbstractControl){
    if (!formControl.parent) {
      return null;
    }
    if (formControl.parent.get('fahrzeugart').value &&
      (formControl.parent.get('fahrzeugart').value.Key === '6' ||  // LKW privat 1,5t
      formControl.parent.get('fahrzeugart').value.Key === '22')) {  // Wohnmobil
      if(formControl.value > 3500){
        return {
          max: {
            max: 3500, actual: formControl.value
          }
        };
      }
    }
    return null;
  }

  static GebaeudeartRequiredValidator(formControl: AbstractControl){
    if (!formControl.parent) {
      return null;
    }

    // Haushalt
    if(formControl.parent.get('produktart').value ===  2 && formControl.value === null || formControl.value === '' ){
      return {
        required: true
      };
    }
  }

  static maxCcmMotorfahrrad(formControl: AbstractControl){
    if (!formControl.parent) {
      return null;
    }

    //Motorfahrrad
    if (formControl.parent.get('fahrzeugart').value && formControl.parent.get('fahrzeugart').value.Key === '10') {
      if(formControl.value > 50){
        return {
          max: {
            max: 50, actual: formControl.value
          }
        };
      }
    }
  }

  static KleinerGleichKeller(formControl: AbstractControl) {
    if (formControl.parent && Number(formControl.value) > Number(formControl.parent.get('kellerFlaecheQm').value)) {
      return {
        max: true
      };
    }
    return null;
  }

  static eurotaxBaujahr(group): any {

    if (group.controls.erstzulassungsdatum.hasError('baujahrMin')) {
      delete group.controls.erstzulassungsdatum.errors['baujahrMin'];
      group.controls.erstzulassungsdatum.updateValueAndValidity();
    }
    if (group.controls.erstzulassungsdatum.hasError('baujahrMax')) {
      delete group.controls.erstzulassungsdatum.errors['baujahrMax'];
      group.controls.erstzulassungsdatum.updateValueAndValidity();
    }
    if (group.controls.erstzulassungsdatum.value &&
      group.controls.baujahrBeginn.value) {
      if (group.controls.erstzulassungsdatum.value.year() < group.controls.baujahrBeginn.value) {
        group.controls.erstzulassungsdatum.setErrors({
          baujahrMin: true
        });
      }
      if (group.controls.baujahrEnde.value &&
        group.controls.erstzulassungsdatum.value.year() > group.controls.baujahrEnde.value) {
        group.controls.erstzulassungsdatum.setErrors({
          baujahrMax: true
        });
      }
    }
    return null;
  }
}

export class CustomErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: UntypedFormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      ((control && control.invalid) ||
        (control && control.parent && control.parent.invalid)) &&
      (control.touched || isSubmitted)
    );
  }
}
